"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyPicker = /** @class */ (function () {
    function CurrencyPicker() {
        this.config = {
            htmlElements: {
                btn: null,
                select: null
            },
            selectors: {
                select: '[data-currency-picker-select]',
                btn: '[data-currency-picker-btn]'
            }
        };
    }
    CurrencyPicker.prototype.init = function () {
        this.config.htmlElements.btn = document.querySelector(this.config.selectors.btn);
        this.config.htmlElements.select = document.querySelector(this.config.selectors.select);
        this.addEventListeners();
    };
    CurrencyPicker.prototype.addEventListeners = function () {
        this.config.htmlElements.btn.addEventListener('click', this.handleSubmit.bind(this));
    };
    CurrencyPicker.prototype.handleSubmit = function (event) {
        event.preventDefault();
        var currency = this.config.htmlElements.select.options[this.config.htmlElements.select.selectedIndex].value;
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);
        if (params.has('currency')) {
            params.set('currency', currency);
        }
        else {
            params.append('currency', currency);
        }
        params = Array.from(params.keys()).reduce(function (acc, key) {
            acc += "&".concat(key, "=").concat(params.get(key));
            return acc;
        }, '');
        params = "?".concat(params.substring(1));
        window.location.replace(window.location.origin + window.location.pathname + params);
    };
    return CurrencyPicker;
}());
exports.default = new CurrencyPicker();
